import React from "react";
import { ChatContent } from "./chat/Chat";
import { ChatModeProvider } from "../providers/ChatModeProvider";
import { useSearchParams } from "react-router-dom";

export const Gallery = () => {
  const [params] = useSearchParams()

  return (
    <ChatModeProvider>
      <div className="flex flex-col items-center justify-center h-screen bg-white/95">
        <ChatContent demo={params.get('demo') === 'true'} />
      </div>
    </ChatModeProvider>
  );
};
